export class HandshakeState {
  private ready = false

  markReady() {
    this.ready = true
  }

  reset() {
    this.ready = false
  }

  isReady() {
    return this.ready
  }
}